(() => {
	angular
		.module('main')
		.controller(
			'QuoteInvoiceTemplatesController',
			QuoteInvoiceTemplatesController
		);

	QuoteInvoiceTemplatesController.$inject = ['$location', 'settingsService'];

	function QuoteInvoiceTemplatesController($location, settingsService) {
		settingsService.timeFormatSettings.take(1).subscribe(settings => {
			if (settings.qtTemplatesAvailable === false) {
				$location.url('/');
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/quoteInvoiceTemplatesController.js